module.exports = __webpack_public_path__ + "assets/static/png/kiev.2f8ab1068b77947d297ef3859e40a8fa.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myElectricity/images/kiev.png
 ** module id = 40
 ** module chunks = 1
 **/